import { Component, inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { NavigationEnd, Router, RouterLink } from "@angular/router";
import { StylingService } from "../../services/styling/styling.service";
import { Store } from "@ngrx/store";
import { AppState } from "../../state/root";
import {
  selectCode,
  selectLoggedInUser,
} from "../../state/user/user.selectors";
import { MatListModule } from "@angular/material/list";
import { MatDivider } from "@angular/material/divider";
import { MatIcon } from "@angular/material/icon";
import { environment } from "../../../../environments/environment";
import { ExperimentalWrapperComponent } from "../experimental-wrapper/experimental-wrapper.component";
import { LYTEHOUSE_ORG_ID } from "../../scripts/client-flags/organisations";
import { AuthoriseDirective } from "../../directives/authorise/authorise.directive";

const MAT_IMPORTS = [MatListModule, MatDivider, MatIcon];

@Component({
  selector: "lh-side-nav",
  standalone: true,
  imports: [
    ...MAT_IMPORTS,
    RouterLink,
    ExperimentalWrapperComponent,
    AuthoriseDirective,
  ],
  templateUrl: "./side-nav.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./side-nav.component.scss",
})
export class SideNavComponent implements OnInit {
  private router = inject(Router);
  private stylingService = inject(StylingService);
  private appStore = inject(Store<AppState>);

  activeRoute = "";
  user = this.appStore.selectSignal(selectLoggedInUser);
  code = this.appStore.selectSignal(selectCode);
  platform = environment.platform;
  readonly lytehouseOrgId = LYTEHOUSE_ORG_ID;
  collapsedSections = new Set<string>(["configuration", "accounts", "reports"]);

  toggleSection(section: string): void {
    if (this.collapsedSections.has(section)) {
      this.collapsedSections.delete(section);
      return;
    }
    this.collapsedSections.add(section);
  }

  isCollapsed(section: string): boolean {
    return this.collapsedSections.has(section);
  }

  public navigate(url: string) {
    this.router.navigate([url]).then(() => {
      this.stylingService.toggleSideNav(false);
    });
  }

  ngOnInit(): void {
    this.activeRoute = this.router.url;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.activeRoute = event.urlAfterRedirects;
      }
    });
  }
}
